import { atom } from "jotai";

export type Locale = "ja" | "en";

const stored = localStorage.getItem("ace-locale") as Locale | null;

export const localeAtom = atom<Locale>(stored || "ja");

export const setLocaleAction = atom(null, (_get, set, locale: Locale) => {
  set(localeAtom, locale);
  localStorage.setItem("ace-locale", locale);
});
